import type { ReactNode } from 'react';
import './back.css';

/**
 * Ícones de ação do app (traço arredondado, mesma família da seta de voltar).
 * Usados nos botões só-ícone das barras de cada página e da conversa.
 */
function Glyph({ children }: { children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export const IconUserPlus = () => (
  <Glyph>
    <circle cx="9.5" cy="8" r="3.4" />
    <path d="M3.4 19.2c.7-3.2 3-5 6.1-5 1.6 0 3 .5 4.1 1.4" />
    <path d="M18 11.5v6M15 14.5h6" />
  </Glyph>
);

export const IconBookDown = () => (
  <Glyph>
    <path d="M6.4 3.8h10.2a1.6 1.6 0 0 1 1.6 1.6v13.2a1.6 1.6 0 0 1-1.6 1.6H6.4a1.6 1.6 0 0 1-1.6-1.6V5.4a1.6 1.6 0 0 1 1.6-1.6Z" />
    <path d="M11.5 8v6.2M8.9 11.8l2.6 2.6 2.6-2.6" />
    <path d="M3.2 8.2h1.6M3.2 12h1.6M3.2 15.8h1.6" />
  </Glyph>
);

export const IconChatPlus = () => (
  <Glyph>
    <path d="M5 6.8A2.8 2.8 0 0 1 7.8 4h8.4A2.8 2.8 0 0 1 19 6.8v6.4a2.8 2.8 0 0 1-2.8 2.8h-4.3l-3.6 3v-3h-.5A2.8 2.8 0 0 1 5 13.2V6.8Z" />
    <path d="M12 7.6v4.8M9.6 10h4.8" />
  </Glyph>
);

export const IconChat = () => (
  <Glyph>
    <path d="M5 6.8A2.8 2.8 0 0 1 7.8 4h8.4A2.8 2.8 0 0 1 19 6.8v6.4a2.8 2.8 0 0 1-2.8 2.8h-4.3l-3.6 3v-3h-.5A2.8 2.8 0 0 1 5 13.2V6.8Z" />
    <path d="M8.8 8.6h6.4M8.8 11.6h4" />
  </Glyph>
);

export const IconBellPlus = () => (
  <Glyph>
    <path d="M6.5 16.5V11a5.5 5.5 0 0 1 9-4.2" />
    <path d="M6.5 16.5 5 18.5h11" />
    <path d="M10 20.5a2.2 2.2 0 0 0 4 0" />
    <path d="M18.5 9.5v6M15.5 12.5h6" />
  </Glyph>
);

export const IconClockPlus = () => (
  <Glyph>
    <path d="M19.6 10.4A8 8 0 1 0 12 20" />
    <path d="M12 7.8V12l2.6 1.8" />
    <path d="M18.5 14.5v6M15.5 17.5h6" />
  </Glyph>
);

export const IconSearch = () => (
  <Glyph>
    <circle cx="10.8" cy="10.8" r="6.2" />
    <path d="m15.6 15.6 4 4" />
  </Glyph>
);

export const IconMore = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <circle cx="12" cy="5.2" r="1.9" />
    <circle cx="12" cy="12" r="1.9" />
    <circle cx="12" cy="18.8" r="1.9" />
  </svg>
);

export const IconClip = () => (
  <Glyph>
    <path d="M16.6 7.4v8.2a4.6 4.6 0 0 1-9.2 0V6.4a3.1 3.1 0 0 1 6.2 0v8.8a1.6 1.6 0 0 1-3.2 0V7.6" />
  </Glyph>
);

export const IconCamera = () => (
  <Glyph>
    <path d="M4.2 9A2.2 2.2 0 0 1 6.4 6.8h1.3l1.2-1.9h6.2l1.2 1.9h1.3A2.2 2.2 0 0 1 19.8 9v7.6a2.2 2.2 0 0 1-2.2 2.2H6.4a2.2 2.2 0 0 1-2.2-2.2V9Z" />
    <circle cx="12" cy="12.6" r="3.3" />
  </Glyph>
);

export const IconSmile = () => (
  <Glyph>
    <circle cx="12" cy="12" r="8.6" />
    <path d="M8.4 13.6c.8 1.5 2 2.2 3.6 2.2s2.8-.7 3.6-2.2" />
    <path d="M9.2 9.9h.01M14.8 9.9h.01" strokeWidth="2.6" />
  </Glyph>
);

/** Volta do painel de emojis para o teclado. */
export const IconKeyboard = () => (
  <Glyph>
    <rect x="3.4" y="6.4" width="17.2" height="11.2" rx="2.6" />
    <path d="M7 10h.01M10.3 10h.01M13.7 10h.01M17 10h.01M7.6 14h8.8" strokeWidth="2.2" />
  </Glyph>
);

export const IconClose = () => (
  <Glyph>
    <path d="M6.5 6.5 17.5 17.5M17.5 6.5 6.5 17.5" />
  </Glyph>
);

export const IconMic = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="9" y="3" width="6" height="11" rx="3" fill="currentColor" />
    <path
      d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const IconSend = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M4 12 20 4l-4 16-4.5-6.5L4 12Z" fill="currentColor" />
  </svg>
);

/** Barra de ações só-ícone de uma página (no lugar que antes repetia a marca). */
export function PageActions({ children }: { children: ReactNode }) {
  return <span className="pg-actions">{children}</span>;
}
